import Index from "components/todolist";
import { useTodoList } from "components/todolist/hooks";
import { FC, useState, useMemo, useEffect } from "react";
import { Tooltip, IconButton } from "@mui/material";
import { AddTask } from "@mui/icons-material";
import moment from "moment-timezone";
import { TodoItemObject } from "types/todolist";

const TodoList: FC = () => {
  const { data: list, mutate: mutateOverdue } = useTodoList(moment.tz.guess(), "today");

  const { data: myList, mutate: mutateMyList } = useTodoList(moment.tz.guess(), "mytask");

  const mutateAll = async () => {
    if (typeof mutateOverdue === "function") {
      await mutateOverdue();
    }
    if (typeof mutateMyList === "function") {
      await mutateMyList();
    }
  };

  const [open, setOpen] = useState(false);

  const overdueCount = useMemo(() => {
    return (
      ((Array.isArray(list) ? list : [])?.filter((item: TodoItemObject) => {
        const tmpDueDate = !!item.repeatMethod && !item.itemId ? item.nextDueDate : item.dueDate;
        return (
          moment()
            .tz(item.userTimezone)
            .isAfter(moment.tz(tmpDueDate, item.userTimezone).add(1, "days")) && !item.completed
        );
      })).length || 0
    );
  }, [list]);
  const todayCount = useMemo(() => {
    return (
      ((Array.isArray(list) ? list : [])?.filter((item: TodoItemObject) => {
        const tmpDueDate = !!item.repeatMethod && !item.itemId ? item.nextDueDate : item.dueDate;

        return (
          moment().tz(item.userTimezone).format("YYYY-MM-DD") === tmpDueDate && !item.completed
        );
      })).length || 0
    );
  }, [list]);

  const pendingCount = useMemo(() => {
    return (
      ((Array.isArray(myList) ? myList : [])?.filter((item: TodoItemObject) => {
        const tmpDueDate = !!item.repeatMethod && !item.itemId ? item.nextDueDate : item.dueDate;

        const now = moment().tz(item.userTimezone);

        return (
          moment.tz(tmpDueDate, item.userTimezone).isAfter(now.clone()) &&
          moment.tz(tmpDueDate, item.userTimezone).isBefore(now.clone().add(7, "days")) &&
          !item.completed
        );
      })).length || 0
    );
  }, [myList]);

  const openMyTodoList = () => {
    setOpen(true);
  };
  const closeMyTodoList = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (window.location.search.includes("showMyTasks=true")) {
      setOpen(true);
    }
  }, []);

  return (
    <>
      <IconButton
        onClick={openMyTodoList}
        sx={{
          position: "relative",
          height: 42,
          width: 42,
          marginRight: 2,
          cursor: "pointer",
          visibility: Array.isArray(list) ? "visible" : "hidden",
          transition: "background-color 0.2s, transform 0.2s",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.15)",
          },
        }}
        /* style={{
          position: "fixed",
          right: 20,
          bottom: 75,
          width: 54,
          height: 54,
          textAlign: "center",
          lineHeight: "66px",
          // background: "rgba(102, 102, 102, 0.65)",
          background: "#000",
          borderRadius: "50%",
          zIndex: 1,
          cursor: "pointer",
          visibility: Array.isArray(list) ? "visible" : "hidden",
        }} */
      >
        <AddTask
          style={{
            color: "#fff",
            fontSize: 28,
          }}
          fontSize="medium"
        />
        {overdueCount > 0 && (
          <Tooltip title="You have overdue tasks">
            <span
              style={{
                position: "absolute",
                top: -4,
                right: -4,
                width: 20,
                height: 20,
                textAlign: "center",
                lineHeight: "20px",
                background: "red",
                borderRadius: "50%",
                zIndex: 2,
                color: "#fff",
                fontSize: 12,
                fontWeight: "bold",
              }}
            >
              {overdueCount}
            </span>
          </Tooltip>
        )}
        {overdueCount === 0 && todayCount > 0 && (
          <Tooltip title="You have tasks due today">
            <span
              style={{
                position: "absolute",
                top: -4,
                right: -4,
                width: 20,
                height: 20,
                textAlign: "center",
                lineHeight: "20px",
                background: "orange",
                borderRadius: "50%",
                zIndex: 2,
                color: "#121212",
                fontSize: 12,
                fontWeight: "bold",
              }}
            >
              {todayCount}
            </span>
          </Tooltip>
        )}
        {overdueCount === 0 && todayCount === 0 && pendingCount > 0 && (
          <Tooltip title="You have tasks due within 7 days">
            <span
              style={{
                position: "absolute",
                top: -4,
                right: -4,
                width: 20,
                height: 20,
                textAlign: "center",
                lineHeight: "20px",
                background: "green",
                borderRadius: "50%",
                zIndex: 2,
                color: "#fff",
                fontSize: 12,
                fontWeight: "bold",
              }}
            >
              {pendingCount}
            </span>
          </Tooltip>
        )}
      </IconButton>
      {open && (
        <Index
          open={open}
          onClose={closeMyTodoList}
          mutateOverdue={mutateAll}
        />
      )}
    </>
  );
};

export default TodoList;
